
import register from 'ShopUiBundle/modules/app/registry';
import 'ShopUiBundle/components/molecules/customer-navigation';

import './style.scss';

// tslint:disable-next-line
register('customer-dropdown', () => import(/* webpackMode: "lazy" */'./customer-dropdown'));
